import script from "./VButton.vue?vue&type=script&setup=true&lang=js"
export * from "./VButton.vue?vue&type=script&setup=true&lang=js"

import "./VButton.vue?vue&type=style&index=0&id=6de9fb9a&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6de9fb9a"]])

export default __exports__